// extracted by mini-css-extract-plugin
export default {"root":"_3u68y","left":"_3k898","right":"_1t3KM","author":"_7BR6f","actions":"_3J_Jd"};